<template>
  <div class="inner-box">
    <form>
      <div class="content-name">
        <h2 class="dp-ib">{{ title }}</h2>
        <div class="btn-wrap btn-type1 clearfix" v-if="$store.state.loginInfo.isSearchAll && form.boardCd !='22'">
          <button type="button" class="btn-size btn-blue fl_left" @click="goWrite()">
            <span class="btn-icon"><i class="fas fa-save"></i></span>
            수정
          </button>
          <button type="button" class="btn-size btn-gray fl_left" @click="goDelete()">
            <span class="btn-icon"><i class="far fa-trash-alt"></i></span>
            삭제
          </button>
        </div>
        <div class="btn-wrap btn-type1 clearfix" v-if="!$store.state.loginInfo.isSearchAll && form.boardCd =='22'">
          <button type="button" class="btn-size btn-blue fl_left" @click="goWrite()" v-if="form.bReply != 'Y'">
            <span class="btn-icon"><i class="fas fa-save"></i></span>
            수정
          </button>
          <button type="button" class="btn-size btn-gray fl_left" @click="goDelete()">
            <span class="btn-icon"><i class="far fa-trash-alt"></i></span>
            삭제
          </button>
        </div>
      </div>
    </form>
    <!-- TABLE  -->
    <div class="table-area">
      <div class="table-a">
        <div class="table-name">
          <h3 class="ico_table_name">게시글</h3>
        </div>
        <table class="table">
          <colgroup>
            <col width="25%;">
            <col width="85%;">
          </colgroup>
          <tbody>
            <tr style="height:5vh;">
              <th>작성자</th>
              <td>{{ form.createdBy }}</td>
            </tr>
            <tr style="height:5vh;">
              <th>작성 일자</th>
              <td>{{ form.creationDate }}</td>
            </tr>
            <tr v-if="form.boardCd=='11'" style="height:5vh">
              <th>분류</th>
              <td>{{ form.boardSubNm }}</td>
            </tr>
            <tr v-if="form.boardCd=='11'" style="height:5vh">
              <th>제품군</th>
              <td>{{ form.productNm }}</td>
            </tr>
            <tr v-if="form.boardCd=='21'" style="height:5vh;">
              <th>공지 등록</th>
              <td>
                <div class="td-flex">
                  <input type="checkbox" id="notic" v-model="form.bPopupFlag" checked disabled /><label for="notic" class="cuTable-chk">&nbsp;&nbsp;&nbsp;&nbsp; 등록&nbsp;&nbsp;</label> 
                  <div v-if="form.bPopupFlag=='Y'" style="display:flex;">
                    /&nbsp;&nbsp; 기간 : &nbsp;&nbsp;
                    <div class="datepicker w-type-ymd02">
                      <div class="input ddate sDate">{{ form.bPopupSdate }}</div>
                    </div>
                    <span class="wave">&nbsp; ~ &nbsp;</span>
                    <div class="datepicker w-type-ymd02">
                      <div class="input ddate sDate">{{ form.bPopupEdate }}</div>
                    </div>
                  </div>
                </div>
                                
              </td>
            </tr>
            <tr v-if="form.boardCd=='22'" style="height:5vh;">
              <th>건의유형</th>
              <td>{{ form.sugNm }}</td>
            </tr>
            <tr v-if="form.boardCd=='22'" style="height:5vh;">
              <th>세부유형</th>
              <td>{{ form.sugDetailNm }}</td>
            </tr>
            <tr style="height:5vh;">
              <th>첨부파일</th>
              <td>
                <ul>
                  <li v-for="(file, index) in files" :key="index"><span class="file-download" @click="fileDownload(file)">{{ file.originalName }}</span></li>
                </ul>
              </td>
            </tr>
            <tr style="height:5vh;">
              <th>제목</th>
              <td>{{ form.bSubject }}</td>
            </tr>
            <tr style="height:30vh;">
              <th>내용</th>
              <td style="padding:0px 0px !important;">
                <vue-editor id="editorR" v-model="form.bContent" :disabled="true" :editor-options="editorOptions" style="height: -webkit-fill-available;"/>
              </td>
            </tr>
                        
          </tbody>
        </table>
      </div>
    </div>
    <!-- TABLE  -->
    <!-- admin 답변 -->
    <div v-if="form.bReply == 'Y'" style="margin-bottom: 20px;">
      <form style="display:flex; justify-content:space-between;">
        <div class="table-name">
          <h3 class="ico_table_name">답변</h3>
        </div>
      </form>
      <div v-for="(reply, i) in adminR" :key="i">
        <div style="float: right;">작성자 : {{ reply.createdBy }} / 등록일자 : {{ reply.creationDate }}</div>
        <textarea style="height:10vh;" v-model="reply.bcontent" readonly/>
        <!-- <div>{{reply.bcontent}}</div> -->
      </div>
    </div>
    <!-- admin 답변 달기 -->
    <div v-if="$store.state.loginInfo.isSearchAll && form.boardCd =='22' && form.bReply != 'Y'">
      <form style="display:flex; justify-content:space-between;">
        <div class="table-name">
          <h3 class="ico_table_name">답변쓰기</h3>
        </div>
        <div class="btn-wrap btn-type1 clearfix">
          <button type="button" class="btn-size btn-blue fl_left" @click="addReply()">
            <span class="btn-icon"><i class="fas fa-save"></i></span>
            저장
          </button>
        </div>
      </form>
      <textarea style="height:10vh;" v-model="admin.bContent"/>
    </div>

  </div>    
</template>
<script>
export default {
    name:'BoardRead',
    data(){
        return {
            title:'',
            boardId:'',
            form:{},
            admin:{
                id:'',
                boardCd:'',
                boardSubCd:'',
                bSubject:'답변',
                bContent:'',
                attribute1:'',
                attribute2:'',
                attribute3:'',
                bReply:'N'
            },
            adminR:[],
            resp:'',
            files:[],
            editorOptions : {
                theme:'bubble'
            }
        }
    },
    created(){
        this.title = this.$route.params.title;
        this.boardId = this.$route.params.boardId;
    },
    mounted(){
        if(!this.boardId){
            this.boardId = this.$store.state.board.boardId;
        }
        if(!this.title){
            this.title = this.$store.state.board.title;
        }
        this.getBoardDetail();
        this.getFileList();
    },
    methods:{
        getBoardDetail(){
            this.$http.get(`/api/board/boardDetail/`+this.boardId)
            .then(respones=>{
                this.form = respones.data
                this.admin.boardCd = this.form.boardCd
                this.admin.attribute3 = this.form.id
                if(this.form.bReply=='Y'){
                    this.$http.get(`/api/board/boardReply/${this.boardId}`)
                    .then(respones=>{
                        this.adminR = respones.data;
                    })
                }
            })
        },
        goWrite(){
            this.$router.push({          
                name: 'boardWrite',
                params: {
                    title : this.title,
                    boardCd : this.form.boardCd,
                    form:this.form,
                    update:'true',
                    file:this.files,
                }
            })    
        },
        getFileList(){
            this.$http.get(`/api/board/file/list/${this.boardId}`)
            .then(respones=>{
                this.files = respones.data.files
            })
        },
        goDelete(){
            this.$http.delete(`api/board/deleteBoard`,{params:{id:this.boardId}})
            .then(respones=>{
                this.$http.post('/api/board/file/removeFiles', {documentHId: this.boardId,})
                .then(response1 => {
                    this.removeFile =response1.data
                })
                this.$swal({
                    type: 'success',
                    text: respones.data
                }).then(() => {
                    if(this.form.boardCd == '11'){
                        this.$router.push({          
                            name: 'listSaleSupportGuide',
                        }) 
                    }else if(this.form.boardCd == '21'){
                        this.$router.push({          
                            name: 'ListNewsletter',
                        }) 
                    }else if(this.form.boardCd == '22'){
                        this.$router.push({          
                            name: 'ListSuggest',
                        }) 
                    }
                })

            })
        },
        fileDownload(file){
            this.$store.commit('loading')
            this.$http.get(`/api/v1/download/board/${file.storedName}`,{ responseType: 'blob' })
            .then((response) => {
                const downloadedfile = new Blob([response.data], { type: 'blob' });
                let url;
  
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'unknown';
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (fileNameMatch.length === 2)
                        fileName = fileNameMatch[1];
                }

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(downloadedfile, fileName);
                } else {
                    url = window.URL.createObjectURL(downloadedfile);
  
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.originalName);
                    document.body.appendChild(link);
                    link.click();
                }
                
            }).catch(response => {
              console.log("catch response" , response)
            }).finally(()=> {
              this.$store.commit('finish');
            });

        },
        addReply(){
            if(!this.admin.bContent){
                this.$swal({type: 'warning', text: '내용을 입력해 주세요.'});
                return false;
            }
            this.form.bReply='Y'
            this.$http.put(`/api/board/updateBoardDetail/${this.form.id}`, this.form)
            
            this.$http.post(`/api/board/addBoard`, this.admin)
            .then(response=>{
                console.log("댓글 저장")
                this.resp = response.data;
                this.$swal({
                    type: 'success',
                    text: '댓글 등록완료.'
                }).then(() => { 
                    this.$router.push({          
                        name: 'ListSuggest',
                    }) 
                })
            })
        }
    },
}
</script>
<style>
#editorR{
    height: 29vh;
    border: none;
}
</style>